import { createContext, ReactNode } from "react";

const ModalContext = createContext<{
  setContent: React.Dispatch<React.SetStateAction<ReactNode>>;
  dialogRef: React.RefObject<HTMLDialogElement>;
}>({ setContent: () => {}, dialogRef: { current: null } });

export default ModalContext;
